<template>
    <v-container fluid>
        <v-row
                align="center"
                justify="center"
                class="text-center">
            <v-col
                    cols="12"
            >
                <v-flex xs12>
                    <v-img
                            class="ml-4 mr-4"
                            :src="language === 'es' ? require('../../assets/residencial_mx.png') : require('../../assets/residencial_eu.png')"
                            height="250px"
                            contain
                    ></v-img>
                </v-flex>
                <div class="text-center">
                    <br>
                    <h3>{{$t('msg_password_reset_done1')}}</h3>
                    <h3>{{$t('msg_password_reset_done2')}}</h3>
                    <br>
                    <v-btn color="primary" to="/">{{ $t('inicio')}}</v-btn>
                </div>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'reset_password_done',
  computed: {
    ...mapState(['language'])
  }
}
</script>

<style scoped>

</style>
